import { ref } from 'vue';

const useGoogleAdClasses = (adId, brand, device, isHeader, isInline, isCatsplash, isProductBottomAd, isBrowse) => {
  const googleAdContainer = ref('');
  googleAdContainer.value = adId === 'GOOGLE_AD_3' ? 'google-ad-container-catsplash' : 'google-ad-container';
  const googleDisplayAd = ref('google-display-ad');
  const googleAdHeader = ref('');
  const googleAdInline = ref('');
  const googleAdCatsplash = ref('');
  const dynamicAdClasses = ref('');
  const googelAdPDPBottom = ref('');
  if (isHeader) {
    if (brand === 'mcom' && isBrowse && adId === 'googleAdOnSearch') {
      googleAdHeader.value = `google-ad-browse-header-${brand}`;
    } else {
      googleAdHeader.value = `google-ad-header-${brand}`;
    }
  }
  if (isCatsplash) googleAdCatsplash.value = 'google-ad-catsplash';
  if (isInline) googleAdInline.value = device === 'desktop' ? `google-ad-inline-${brand}` : `google-ad-inline-mobile-${brand}`;
  if (isProductBottomAd) googelAdPDPBottom.value = 'google-ad-pdp-bottom';
  return {
    googleAdContainer,
    googleDisplayAd,
    googleAdHeader,
    googleAdInline,
    googleAdCatsplash,
    dynamicAdClasses,
    googelAdPDPBottom,
  };
};

export default useGoogleAdClasses;
